import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PropertyDeliveriesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PropertyDeliveriesError', ...args);
    }
}
export default PropertyDeliveriesError;
